/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramExchangeRateControllerFindAllQueryResponse } from '../types/TelegramExchangeRateControllerFindAll.ts';

function getTelegramExchangeRateFindAllUrl() {
  const res = { method: 'GET', url: `/api/telegram/exchange-rates` as const };
  return res;
}

/**
 * {@link /api/telegram/exchange-rates}
 */
export async function telegramExchangeRateFindAll(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramExchangeRateControllerFindAllQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramExchangeRateFindAllUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
